import * as validations from '../../../../validations/validations';

import { Col } from 'reactstrap';
import { FormInput } from '../../../';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import IntervalsFormProps from '../IntervalsFormProps';
import React from 'react';
import objectHelper from '../../../../utils/ObjectHelper';
import { observer } from 'mobx-react';

const AIIntervalField = ({ translate, intervalModel, disabled }: IntervalsFormProps) => <Col>
  <FormInput {...{
    model: new FormInputModel({
      readonly: disabled,
      validationSchema: validations.getBasicNumberSchema(),
      placeholder: translate(x => x.forms.airdome.intervals.aiInterval),
      handleValueModel: new HandleValueModel({
        setValue: intervalModel.artificialIntelligenceInterval.setValue,
        inputType: 'number'
      }),
      label: translate(x => x.forms.airdome.intervals.aiInterval),
      inputId: 'AiInterval',
      value: objectHelper.executeIfNumber(intervalModel.artificialIntelligenceInterval.Value, x => x.toString()) || ''
    })
  }} />
</Col>;

export default observer(AIIntervalField);
